function processValue(value) {
  return Array.isArray(value) ? value.map(processValue) : value === Object(value) && !(value instanceof Date) ? excludeUndefined(value) : value;
}
export function excludeUndefined(obj) {
  return Object.fromEntries(Object.entries(obj).filter(_ref => {
    let [_, v] = _ref;
    return v !== undefined;
  }).map(_ref2 => {
    let [k, v] = _ref2;
    return [k, processValue(v)];
  }));
}
//# sourceMappingURL=excludeUndefined.js.map